<template>
    <div>
        <div class="t_h2_txt1">
            <i class="el-icon-back return_icon" @click="$router.go(-1)"></i>{{data_all.card_name}}
        </div>

        <div class="th_info">
            <div class="th_info_top">{{$t('bank_card.View_the_contract')}}</div>
            <div class="th_info_main">
                <!-- <div class="th_tit1">{{$t('bank_card.Personal_Details')}}</div> -->
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text142')}}</div>
                    <div class="th_tit4">{{contract_data.company_name}}</div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.email')}}</div>
                    <div class="th_tit4">{{contract_data.email}}</div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text324')}}</div>
                    <div class="th_tit4">{{overall_time2(contract_data.start_time)}}</div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.Contract_term_month')}}</div>
                    <div class="th_tit4">{{contract_data.month_limit}}</div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text325')}}</div>
                    <div class="th_tit4">{{overall_time2(contract_data.end_time)}}</div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text142')}}</div>
                    <div class="th_tit4">{{contract_data.company_name}}</div>
                </div>

                <!-- <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.card_array')}}</div>
                    <div class="th_tit4">{{ contract_data.card_array_name }}</div>
                </div> -->

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.card_level')}}</div>
                    <div class="th_tit4">{{ contract_data.card_level_name }}</div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.Card_class')}}</div>
                    <div class="th_tit4">{{ contract_data.card_type_name }}</div>
                </div>

                <!-- <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.branded_card_category')}}</div>
                    <div class="th_tit4">
                        <span v-for="(item,index) in card_category_list" :key="item.value">{{ item.name }}<span v-if="index<card_category_list.length-1">、</span></span>
                    </div>
                </div> -->

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.contract_quantity')}}</div>
                    <div class="th_tit4">{{contract_data.total_amount}}</div>
                </div>

                <div v-for="(item,index) in payment_details" :key="index">
                    <template v-if="index==0">
                        <!-- <div class="th_tit2">
                            <div class="th_tit3">{{$t('bank_card.Number_reservation')}}</div>
                            <div class="th_tit4">{{ item.rate*100 }} %</div>
                        </div> -->
                        <div class="th_tit2">
                            <!-- <div class="th_tit3"></div> -->
                            <div class="th_tit3">{{$t('bank_card.Number_reservation')}}</div>
                            <div class="th_tit4">{{ item.amount }} {{$t('bank_card.zhang')}}</div>
                        </div>
                        <div class="th_tit2" style="margin-bottom: 12px;">
                            <div class="th_tit3">{{$t('bank_card.date_of_payment')}}</div>
                            <div class="th_tit4">{{ overall_time2(item.time) }} </div>
                        </div>
                    </template>
                    <template v-else>
                        <!-- <div class="th_tit2">
                            <div class="th_tit3">{{$t('bank_card.di')}} {{index+1}} {{$t('bank_card.Period_quantity')}}</div>
                            <div class="th_tit4">{{ item.rate*100 }} %</div>
                        </div> -->
                        <div class="th_tit2">
                            <div class="th_tit3">{{$t('bank_card.di')}} {{index+1}} {{$t('bank_card.Period_quantity')}}</div>
                            <div class="th_tit4">{{ item.amount }} {{$t('bank_card.zhang')}}</div>
                        </div>
                        <div class="th_tit2" style="margin-bottom: 12px;">
                            <div class="th_tit3">{{$t('bank_card.date_of_payment')}}</div>
                            <div class="th_tit4">{{ overall_time2(item.time) }} </div>
                        </div>
                    </template>
                </div>


                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.Minimum_order_quantity')}}</div>
                    <div class="th_tit4">{{contract_data.min_amount}}</div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.left_amount')}}</div>
                    <div class="th_tit4">{{contract_data.left_amount}}</div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.available_quantity')}}</div>
                    <div class="th_tit4">{{contract_data.order_amount}}</div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.Current_number_audited')}}</div>
                    <div class="th_tit4">{{contract_data.pending_amount}}</div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.Current_number_issued')}}</div>
                    <div class="th_tit4">{{contract_data.pending_success_amount}}</div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.card_cost_status')}}</div>
                    <div class="th_tit4">
                        <!-- card_cost_status: 卡费状态 0未缴纳 1已缴纳 -->
                        <span v-if="contract_data.card_cost_status==0">{{$t('bank_card.card_cost_status0')}}</span>
                        <span v-else-if="contract_data.card_cost_status==1">{{$t('bank_card.card_cost_status1')}}</span>
                        <span v-else>-</span>
                    </div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.card_cost')}}</div>
                    <div class="th_tit4">{{contract_data.card_cost*1}}</div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.annual_fee_status')}}</div>
                    <div class="th_tit4">
                        <!-- annual_fee_status: 年费状态 0未缴纳 1已缴纳 -->
                        <span v-if="contract_data.annual_fee_status==0">{{$t('bank_card.card_cost_status0')}}</span>
                        <span v-else-if="contract_data.annual_fee_status==1">{{$t('bank_card.card_cost_status1')}}</span>
                        <span v-else>-</span>
                    </div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text503')}}</div>
                    <div class="th_tit4">{{contract_data.annual_fee*1}}</div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.card_replace_fee')}}</div>
                    <div class="th_tit4">{{contract_data.card_replace_fee*1}}</div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text510')}}</div>
                    <div class="th_tit4" v-if="contract_data.top_up_fee">{{calc_fee(contract_data.top_up_fee)}}</div>
                    <div class="th_tit4" v-else>-</div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text786')}}</div>
                    <div class="th_tit4" v-if="contract_data.top_up_fee_direct">{{calc_fee(contract_data.top_up_fee_direct)}}</div>
                    <div class="th_tit4" v-else>-</div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.min_top_up')}}</div>
                    <div class="th_tit4">{{set_num3_2(contract_data.min_top_up*1)}}</div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.max_top_up')}}</div>
                    <div class="th_tit4">{{set_num3_2(contract_data.max_top_up*1)}}</div>
                </div>

                <!-- <div class="th_tit2">
                    加价价格
                    <div class="th_tit3">{{$t('bank_card.plus_price')}}</div>
                    <div class="th_tit4">{{contract_data.plus_price*1}}</div>
                </div> -->

                <!-- <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.sale_name')}}</div>
                    <div class="th_tit4">{{contract_data.sale_name||"-"}}</div>
                </div> -->

                <div class="th_tit1">{{$t('bank_card.design_details')}}</div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.design_category')}}</div>
                    <div class="th_tit4">{{contract_data.design_details.design_category}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.material')}}</div>
                    <div class="th_tit4">{{contract_data.design_details.material||"-"}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.material_color')}}</div>
                    <div class="th_tit4">{{contract_data.design_details.material_color||"-"}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.font_color')}}</div>
                    <div class="th_tit4">{{contract_data.design_details.font_color||"-"}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.feb_logo')}}</div>
                    <div class="th_tit4">
                        <el-image 
                            v-if="contract_data.design_details.feb_logo"
                            class="fd_img_box"
                            :src="contract_data.design_details.feb_logo" 
                            :preview-src-list="[contract_data.design_details.feb_logo]">
                        </el-image>
                        <span v-else>-</span>
                    </div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.merchant_logo')}}</div>
                    <div class="th_tit4">
                        <el-image 
                            v-if="contract_data.design_details.merchant_logo"
                            class="fd_img_box"
                            :src="contract_data.design_details.merchant_logo" 
                            :preview-src-list="[contract_data.design_details.merchant_logo]">
                        </el-image>
                        <span v-else>-</span>
                    </div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.card_picture')}}</div>
                    <div class="th_tit4">
                        <el-image 
                            v-if="contract_data.design_details.card_picture"
                            class="fd_img_box"
                            :src="contract_data.design_details.card_picture" 
                            :preview-src-list="[contract_data.design_details.card_picture]">
                        </el-image>
                        <span v-else>-</span>
                    </div>
                </div>

                <div class="th_tit1">{{$t('bank_card.Packing_arrangement')}}</div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.packaging_type')}}</div>
                    <div class="th_tit4">{{contract_data.package_details.packaging_type||"-"}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.done_by')}}</div>
                    <div class="th_tit4">{{contract_data.package_details.done_by||"-"}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.cost_to_client')}}</div>
                    <div class="th_tit4">{{contract_data.package_details.cost_to_client||"-"}}</div>
                </div>

                <div class="th_tit1">{{$t('bank_card.delivery_type')}}</div>
                <template v-if="contract_data.mailing_details.type_id==1">
                    <div v-for="(item,index) in contract_data.mailing_details.stages" :key="index+item.delivery_address" class="stage_box">
                        <div class="th_tit2">
                            <div class="th_tit3">{{$t('bank_card.stage')}}</div>
                            <div class="th_tit4">{{item.stage||"-"}}</div>
                        </div>
                        <div class="th_tit2">
                            <div class="th_tit3">{{$t('bank_card.from_to')}}</div>
                            <div class="th_tit4">{{item.from_to||"-"}}</div>
                        </div>
                        <div class="th_tit2">
                            <div class="th_tit3">{{$t('bank_card.printing_type')}}</div>
                            <div class="th_tit4">{{item.printing_type||"-"}}</div>
                        </div>
                        <div class="th_tit2">
                            <div class="th_tit3">{{$t('bank_card.delivery_note')}}</div>
                            <div class="th_tit4">{{item.delivery_note||"-"}}</div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div v-for="(item,index) in contract_data.mailing_details.stages" :key="index+item.delivery_address" class="stage_box">
                        <div class="th_tit2">
                            <div class="th_tit3">{{$t('bank_card.stage')}}</div>
                            <div class="th_tit4">{{item.stage||"-"}}</div>
                        </div>
                        <div class="th_tit2">
                            <div class="th_tit3">{{$t('bank_card.from_to')}}</div>
                            <div class="th_tit4">{{item.from_to||"-"}}</div>
                        </div>
                        <div class="th_tit2">
                            <div class="th_tit3">{{$t('bank_card.printing_type')}}</div>
                            <div class="th_tit4">{{item.printing_type||"-"}}</div>
                        </div>
                        <div class="th_tit2">
                            <div class="th_tit3">{{$t('bank_card.delivery_address')}}</div>
                            <div class="th_tit4">{{item.delivery_address||"-"}}</div>
                        </div>
                        <div class="th_tit2">
                            <div class="th_tit3">{{$t('bank_card.contract')}}</div>
                            <div class="th_tit4">{{item.contract||"-"}}</div>
                        </div>
                        <div class="th_tit2">
                            <div class="th_tit3">{{$t('bank_card.mobile_no')}}</div>
                            <div class="th_tit4">{{item.mobile_no||"-"}}</div>
                        </div>
                        <div class="th_tit2">
                            <div class="th_tit3">{{$t('bank_card.email')}}</div>
                            <div class="th_tit4">{{item.email||"-"}}</div>
                        </div>
                        <div class="th_tit2">
                            <div class="th_tit3">{{$t('bank_card.delivery_note')}}</div>
                            <div class="th_tit4">{{item.delivery_note||"-"}}</div>
                        </div>
                    </div>
                </template>
                
                
                
                

            </div>
        </div>
    </div>
</template>

<script>
import {getContract} from '@/api/api';
import BigNumber from "bignumber.js";
export default {
    data() {
        return {
            data_all:'',
            order_id:this.$route.query.id,
            contract_data:{
                design_details:{},
                package_details:{},
                mailing_details:{
                    stages:[]
                }
            },
            payment_details:[],
            card_category_list:[],
        }
    },
    beforeDestroy(){
        sessionStorage.removeItem('top_title_name');
    },
    mounted() {
        sessionStorage.setItem('top_title_name',' ');
        this.get_list();
    },
    methods: {
        calc_fee(v){
            return BigNumber(v).times(100)+" %";
        },
        async get_list(){
            const res = await getContract({
                tx_id:this.order_id,
            });
            if (res.data.code !== 200) {
                return this.message.ismessage('error',res.data.msg);
            }
            this.contract_data = res.data.data;
            this.payment_details = JSON.parse(res.data.data.payment_details);
            const c_list = [...res.data.data.card_category];
            const c_list2 = [];
            for (const i of c_list) {
                if(i==1){
                c_list2.push({"name":this.$t('bank_card.VISA'),'value':i})
                }else if(i==2){
                c_list2.push({"name":this.$t('bank_card.Mastercard'),'value':i})
                }else if(i==3){
                c_list2.push({"name":this.$t('bank_card.UnionPay'),'value':i})
                }
            }
            this.card_category_list = c_list2;
        },

    },
}
</script>

<style scoped>
.th_info{
    background: #314B69;
    border-radius: 16px;
}
.th_info_top{
    box-sizing: border-box;
    padding: 28px;
    border-bottom: 1.5px solid #041E35;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
}
.th_info_main{
    box-sizing: border-box;
    padding: 28px;
}
.th_tit1{
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 18px;
    margin-bottom: 12px;
    margin-top: 20px;
}
.th_tit2{
    margin-bottom: 12px;
    display: flex;
}
.th_info_main .th_tit2:last-child{
    margin-bottom: 0;
}
.th_tit3{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.6);
    width: 160px;
    margin-right: 28px;
    display: inline-block;
}
.th_tit4{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    display: inline-block;
}
.title_bottom{
    margin-top: 30px;
}
.return_icon{
  cursor: pointer;
  margin-right: 10px;
}
.t_h2_txt1{
  font-style: normal;
  font-size: 20px;
  line-height: 26px;
  margin-bottom: 15px;
}
.fd_img_box{
    max-width: 260px;
    max-height: 160px;
    display: block;
    margin-bottom: 5px;
}
.stage_box{
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #041E35;
}
</style>